import React, { useCallback, useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';

import { Box } from '@mui/material';

import { useAcademyActivityByMonth } from 'modules/billing/hooks/useAcademyActivityByMonth';
import { AcademyActivityByMonthTable } from '@ts-core/modules/billing/components/AcademyActivityByMonthTable';
import { YearMonthSelector, YearMonthDate } from '@ts-core/modules/billing/components/YearMonthSelector';

import { useNewBillingStartingDateComponents } from 'modules/billing/hooks/useNewBillingStartingDateComponents';
import { ActivityOverviewTiles } from '../components/ActivityOverviewTiles';

const thisYear = new Date().getFullYear().toString();
const thisMonth = (new Date().getMonth() + 1).toString();

export default function PaymentOverviewPage() {
  const history = useHistory();
  const { month: urlMonth, year: urlYear } = useParams<{ year: string; month: string }>();
  const [date, setDate] = useState<YearMonthDate>({ year: urlYear ?? thisYear, month: urlMonth ?? thisMonth });
  const { year, month } = date;
  const { academyActivity, loading } = useAcademyActivityByMonth({ month, year });

  const { year: minYear, month: minMonth } = useNewBillingStartingDateComponents();

  const handleGoToCourse = useCallback(
    (courseId) => {
      history.push(`/billing/${year}/${month}/${courseId}`);
    },
    [history, month, year]
  );

  useEffect(() => {
    const { year, month } = date;
    history.replace(`/billing/${year}/${month}`);
  }, [date, history]);

  return (
    <Box>
      <YearMonthSelector sx={{ mt: 3, mb: 2 }} date={date} onChangeDate={setDate} minYear={minYear} minMonth={minMonth} />
      <ActivityOverviewTiles loading={loading} activityOverview={academyActivity} />
      <AcademyActivityByMonthTable academyActivity={academyActivity} loading={loading} onGoToCourse={handleGoToCourse} />
    </Box>
  );
}
